import React, { Fragment, useState, useContext, useEffect } from 'react';
import TableBuilder, { ApiRequestBuilder } from '../../../GlobalComponents/Builders';
import { Container, Row, Card, CardBody } from 'reactstrap'
import { Link } from 'react-router-dom';

const Roles = () => {

    const [isProcessing, setIsProcessing] = useState(true);
    const [rolesData, setRolesData] = useState([]);

    useEffect(() => {
    
        document.title = 'View Roles'

        ApiRequestBuilder('rolesGet', null, null, { setIsProcessing })
            .then(function(results) {
                results && results.data.length > 0 ? setRolesData(results.data) : []
            }
        )
    }, []);

    return (
            <Fragment>
                <Row>
                    <Container>
                        <Card>
                        <CardBody>
                            <TableBuilder
                                data={rolesData}
                                title='Roles'
                                sortField={null}
                                //subHeader={true}
                                processing={isProcessing}
                                //columnsToSearch={['first_name', 'last_name', 'request_url']}
                                columns = {[
                                    {
                                        name: 'Name',
                                        selector: (row) => row.name,
                                        sortable: true,
                                        center: true,
                                    },
                                    {
                                        name: 'Description',
                                        selector: (row) => row.description,
                                        sortable: true,
                                        center: true,
                                    },
                                    {
                                        name: 'Users',
                                        selector: (row) => row.users.length,
                                        sortable: true,
                                        center: true,
                                    },
                                    {
                                        name: 'Manage',
                                        selector: (row) => <Link to={`${process.env.PUBLIC_URL}/users/roles/` + row.role_id}>View / Edit</Link>,
                                        sortable: true,
                                        center: true
                                    }
                                ]}
                            />
                        </CardBody>
                        </Card>
                    </Container>
                </Row>
            </Fragment>
    );
};

export default Roles;